import { connect } from 'react-redux'
import { AppState, Dispatch } from '../../../../types'
import { notifyEvent, notifyIframeError } from '../../../Iframe/actions'
import { selectors as authSelectors } from '../../../../lifecycle/auth'
import { Profile } from '../../../../remote-api/CoreServicesRemoteApi'
import CustomDashboardIframe, { ValueProps, EventProps, ExternalProps } from './CustomDashboardIframe'
import { fetchLabels } from '../../../../common/labels/actions';

const mapStateToProps = (rootState: AppState, ownProps: ExternalProps): ValueProps => ({
  ...ownProps,
  profile: (authSelectors.getProfile(rootState).getOrUndefined()) as Profile | undefined,
  labels: rootState.monitoring.labels.resources,
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  notifyEvent: (type: string, event: string, detail: any) => dispatch(notifyEvent(type, event, detail)),
  notifyError: (error: any) => dispatch(notifyIframeError(error)),
  fetchLabels: () => dispatch(fetchLabels('monitoring')),
})

export default connect(mapStateToProps, mapDispatch)(CustomDashboardIframe)
